import { type FC } from 'react'
import { type AccountOpeningHoldersPanel } from '../../../models/AccountOpeningDescriptor'
import { AccountHolderFields } from '../intake/AccountHolderFields'
import { type ResolvedItem } from '../domain/collections'
import { useWizardFlow } from '../hooks/WizardFlowContext'
import { type ItemPatch } from '../domain/types'

interface PanelHoldersProps {
  item: ResolvedItem
  panel: AccountOpeningHoldersPanel
  onChange: (patch: ItemPatch) => void
}

export const PanelHolders: FC<PanelHoldersProps> = ({ item, panel, onChange }) => {
  const { ctx, accountTypes, selectors, contactOptions, defaultHolderContactId, readOnly } = useWizardFlow()

  if (item.collection !== 'accounts') {
    return null
  }

  return (
    <AccountHolderFields
      accountTypes={accountTypes}
      selectors={selectors}
      panel={panel}
      account={item.account}
      contactOptions={contactOptions}
      defaultHolderContactId={defaultHolderContactId}
      accountId={ctx.accountId}
      disabled={readOnly}
      onChange={(updated) => onChange({ holders: updated.holders })}
    />
  )
}
